import { useSelector } from "react-redux";
import { allTrackers } from "app/services/track/track";
import { selectHsMissingRequiredFieldsCount } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspot/exportSelectors";
import { selectSfMissingRequiredFieldsCount } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforce/exportSelectors";
import { selectDynamicsMissingRequiredFieldsCount } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/dynamics/exportSelectors";
import type { ExportName } from "app/pages/sales-intelligence/sub-modules/management/store/type";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

const selectMissingRequiredFieldsCountConfig = {
    hubspot: selectHsMissingRequiredFieldsCount,
    salesforce: selectSfMissingRequiredFieldsCount,
    dynamics: selectDynamicsMissingRequiredFieldsCount,
};

export const useMissingMandatoryFieldsModalTracking = (recordName: ExportName | null) => {
    const { integrationName } = getIntegrationNameFromUrl();

    const missingRequiredFieldsCount = useSelector(
        selectMissingRequiredFieldsCountConfig[integrationName as Integration],
    );

    const isMissingMandatoryFieldsWarningVisible = !!recordName && missingRequiredFieldsCount[recordName] > 0;

    const trackEventSubName = isMissingMandatoryFieldsWarningVisible ? "with warning text" : "no warning text";

    const trackConfirm = () =>
        allTrackers.dispatchTrackEvent(
            `${integrationName} integration`,
            "proceed to mapping",
            `missing mandatory fields/proceed/${trackEventSubName}`,
        );

    const trackCancel = () =>
        allTrackers.dispatchTrackEvent(
            `${integrationName} integration`,
            "cancel activation",
            `missing mandatory fields/cancel/${trackEventSubName}`,
        );

    return { trackConfirm, trackCancel };
};
